// src/components/3D/GardenMesh.jsx
import React, { useMemo } from 'react';
import { Text } from '@react-three/drei';
import { createGrassTexture } from '../../utils/textureUtils';

const GardenMesh = React.memo(({ element, position }) => {
  const grassTexture = useMemo(() => createGrassTexture(), []);
  grassTexture.repeat.set(element.width/100, element.height/100);

  const hasWater = element.properties.hasWaterFeature || 
    element.type === 'Eco-Pond' || 
    element.type === 'Community Lake';

  return (
    <group position={[position[0], 0, position[1]]}>
      {/* Base Garden Ground - rotated to be horizontal */}
      <mesh 
        receiveShadow
        rotation={[-Math.PI/2, 0, 0]}
      >
        <planeGeometry args={[element.width/40, element.height/40]} />
        <meshStandardMaterial 
          map={grassTexture} 
          color={element.color}
        />
      </mesh>

      {/* Water Feature - also horizontal */}
      {hasWater && (
        <mesh 
          position={[0, 0.05, 0]} 
          rotation={[-Math.PI/2, 0, 0]}
        >
          <circleGeometry args={[Math.min(element.width, element.height)/100, 32]} />
          <meshStandardMaterial 
            color="#4169E1"
            transparent
            opacity={0.7}
            metalness={0.3}
            roughness={0.1}
          />
        </mesh>
      )}

      {/* Label */}
      <Text
        position={[0, 0.5, 0]}
        rotation={[-Math.PI/2, 0, 0]}
        fontSize={0.5}
        color="black"
        anchorX="center"
        anchorY="middle"
      >
        {element.type}
      </Text>
    </group>
  );
});

export default GardenMesh;